import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { NavLink, useParams } from "react-router";
import { CustomerName } from "@/services/backend/customers/components/customer-name";
import { Fragment, ReactNode } from "react";
import { SidebarTrigger } from "@/shared/components/ui/sidebar";
import { Separator } from "@/shared/components/ui/separator";

export function CustomerPageBreadcrumbs({
  breadcrumbs,
}: {
  breadcrumbs: { to: string; label: ReactNode }[];
}) {
  const { customerId } = useParams();

  return (
    <div className="flex items-center gap-2">
      <SidebarTrigger />
      <Separator orientation="vertical" className="mr-2 h-4" />
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem className="whitespace-nowrap md:whitespace-normal">
            <BreadcrumbLink asChild>
              <NavLink to={`/customers/${customerId}`}>
                <CustomerName customerId={customerId!} />
              </NavLink>
            </BreadcrumbLink>
          </BreadcrumbItem>
          {breadcrumbs.map((breadcrumb) => (
            <Fragment key={breadcrumb.to}>
              <BreadcrumbSeparator className="hidden md:block" />
              <BreadcrumbItem key={breadcrumb.to}>
                <BreadcrumbLink asChild>
                  <NavLink to={breadcrumb.to}>{breadcrumb.label}</NavLink>
                </BreadcrumbLink>
              </BreadcrumbItem>
            </Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
}
